import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material';
import { MAT_DIALOG_DATA } from '@angular/material';
import { PropertyType } from '../property-type.model';
import { CollateralskillsetsService } from '../collateralskillsets.service';
import { PropertyTypeService } from '../property-type.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-property-type-edit',
  templateUrl: './property-type-edit.component.html',
  styleUrls: ['./property-type-edit.component.css']
})
export class PropertyTypeEditComponent implements OnInit {
    public editForm: FormGroup;
    public productSkillSets = [];
    public propertyFields;

    constructor(public dialogRef: MatDialogRef<PropertyTypeEditComponent>,
        @Inject(MAT_DIALOG_DATA) public propertyType: PropertyType, public dialog: MatDialog, public fb: FormBuilder,
        private collateralSkilSetService: CollateralskillsetsService, private propertyTypeService: PropertyTypeService) {
        this.createForm();
    }

    ngOnInit() {
        this.propertyFields = environment.propertyFields;
        this.getProductSkillset();
        this.editForm.controls.propertyTypeControl.setValue(this.propertyType.name);
        this.editForm.controls.productSkillSetControl.setValue(this.propertyType.productSkillsetId);
        this.editForm.controls.propertyFieldControl.setValue(this.propertyType.propertyField);
        this.editForm.controls.isRetailControl.setValue(this.propertyType.isRetail);
    }

    createForm() {
        this.editForm = this.fb.group({
            propertyTypeControl : ['', [Validators.required, Validators.maxLength(255)]],
            productSkillSetControl : [null, Validators.required],
            propertyFieldControl: [null, Validators.required],
            isRetailControl : [false]
        })
    }

    async getProductSkillset() {
        let result = await this.collateralSkilSetService.getProductSkillSet();
        this.productSkillSets = result;
    }

    async savePropertyType() {
        if (!this.editForm.valid) {
            return;
        }
        const formModel = this.editForm.value;
        const updatePropertyType: PropertyType = {
            id: this.propertyType.id as string,
            name: formModel.propertyTypeControl as string,
            productSkillsetId: formModel.productSkillSetControl as string,
            propertyField: formModel.propertyFieldControl as string,
            isRetail: formModel.isRetailControl as boolean
        };

        let result = await this.propertyTypeService.updatePropertyTypes(updatePropertyType);
        this.dialogRef.close(updatePropertyType);
    }

    isRetailCheckboxChange(event) {

    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/collateralskillsets/property-type-edit/property-type-edit.component.ts